<!--
  * @Author: changyunxia
  * @Date:2020年09月28日 11:58:52
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年09月28日 11:58:52
  * @Description: 会议室预定 月预览
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>
    <div>
      <meetingCalendar :meeting-type="'meeting'" />
    </div>
    <van-calendar
      ref="calendar"
      :show-title="false"
      :poppable="false"
      :show-confirm="false"
      :lazy-render="false"
      :color="'#fff'"
      :formatter="formatter"
      :default-date="new Date()"
      :style="{ height: '430px' }"
      @select="selectDate"
    />

    <div id="test" />

  </div>

</template>

<script>
// import $ from 'jquery'
import meetingCalendar from '@/components/meeting/meetingCalendar'

export default {
  name: 'MouthSelect',
  components: { meetingCalendar },
  props: {
    meetingData: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      // meetingAllDetails: this.meetingData,
      // 会议开始日期
      starDate: [],
      // 会议开始数据
      allData: [],
      // starHShow: false,
      // 点击日历获取的日期
      clickDate: null,
      num: [],
      // 获取当前会议室
      roomCode: {}

    }
  },
  computed: {},
  watch: {
    meetingData: {
      handler(newVal, oldVal) {
        // this.meetingAllDetails = newVal
        // const obj = { text: '会议室03', index: '03' }
        // this.getMeetingDataFunc(obj)
      },
      immediate: true
    },
    starH(navl) {
      // this.starHShow = true
    }
  },
  created() {
    const obj = { text: '会议室01', index: '01' }
    this.getMeetingDataFunc(obj)
  },
  mounted() {

  },
  methods: {
    getMeetingDataFunc(val) {
      this.roomCode.roomName = val.text
      this.roomCode.room_code = val.index
      const chArr = document.body.getElementsByClassName('test')
      for (let k = chArr.length - 1; k >= 0; k--) {
        // 删除元素 元素.parentNode.removeChild(元素);
        if (chArr[k] !== null) {
          chArr[k].parentNode.removeChild(chArr[k])
        }
      }

      this.starH = []
      var arr = []
      // 数据分类处理
      const dataInfo = {}
      this.meetingData.forEach(element => {
        if (element.room_code === val.index) {
          // arr.push(element.startime)
          this.allData.push(element)
          const { startime } = element
          if (!dataInfo[startime]) {
            dataInfo[startime] = {
              startime,
              child: []
            }
          }
          dataInfo[startime].child.push(element)
        }
      })

      // this.starDate = Object.values(dataInfo)
      arr = Object.values(dataInfo)
      // 时间排序
      // this.$nextTick(() => {
      this.starDate = Array.from(new Set(arr)).sort(function(a, b) {
        return b.startime < a.startime ? 1 : -1
      })
    },
    // 点击日期事件
    selectDate(e) {
      const chArr = document.body.getElementsByClassName('test')
      for (let k = chArr.length - 1; k >= 0; k--) {
        // 删除元素 元素.parentNode.removeChild(元素);
        if (chArr[k] !== null) {
          chArr[k].parentNode.removeChild(chArr[k])
        }
      }
      this.clickDate = this.$moment(e).format('YYYY-MM-DD')
      var data = this.starDate.find((value, index, arr) => {
        return value.startime === this.clickDate
      })
      if (data) {
        this.$emit('dialogshowFunc', true, this.clickDate, data.child)
      } else {
        const arrRoom = []
        arrRoom.push(this.roomCode)
        this.$emit('dialogshowFunc', true, this.clickDate, arrRoom)
      }
    },
    // 时间备注
    formatter(day) {
      // var _this = this
      // 获取当月时间
      const data2 = this.$moment(day.date).format('YYYY-MM-DD')
      for (let i = 0; i < this.starDate.length; i++) {
        const element = this.starDate[i]
        const data1 = this.$moment(element.startime).format('YYYY-MM-DD')
        // day.bottomInfo = ' '
        if (data1 === data2) {
          day.bottomInfo = '  '
          const child = element.child
          setTimeout(function() {
            var oPNode = document.getElementsByClassName('van-calendar__bottom-info')
            var ul = document.createElement('ul')
            ul.classList.add('test')
            for (let j = 0; j < 36; j++) {
              var li = document.createElement('li')
              ul.appendChild(li)
            }
            // oPNode[i].append(ul)
            for (let h = 0; h < child.length; h++) {
              for (let n = 0; n < 36; n++) {
                if (child[h].startime === data2 && n >= child[h].starNum && n <= child[h].endNum) {
                  ul.childNodes[n].style.backgroundColor = child[h].color
                }
              }
            }
            if (oPNode[i]) {
              oPNode[i].appendChild(ul)
            }
          }, 500)
        }
      }

      return day
    },
    cearteFunc(data2, oPNode, child, i) {
      // var oPNode = $('.van-calendar__bottom-info')
      // console.log(oPNode)
      var ul = document.createElement('ul')
      ul.classList.add('test')
      for (let j = 0; j < 36; j++) {
        var li = document.createElement('li')
        ul.appendChild(li)
      }
      // oPNode[i].append(ul)
      for (let h = 0; h < child.length; h++) {
        for (let n = 0; n < 36; n++) {
          if (data2 === child[h].startime && n >= child[h].starNum && n <= child[h].endNum) {
            ul.childNodes[n].style.backgroundColor = child[h].color
          }
        }
      }
      // console.log(oPNode)
      // console.log(oPNode[i])
      oPNode[i].append(ul)
    }
  }
}
</script>
<style>
#test{
  display: none;
}
.test{
  position: relative;
  z-index: 20;
}
.test li{
  background: #f1f1f1;
  display: inline-block;
  width:5.5%;
  height: 7px;
  margin-bottom: -8px;
}
</style>
<style lang="scss" scoped>
.test{
  width: 100px;
  height:50px;
}
.test li{
  background: #f1f1f1;
  display: inline-block;
}
/deep/.van-calendar__selected-day {
    color: #c10000;
    border-radius: 4px;
    padding: 2px 4px;
    border-radius: 200px;
    width: 14px;
    height: 16px;
    font-size: 20px;
    font-weight: bolder;
}
/deep/.van-calendar__bottom-info{
    // background: red;
    margin: 0 1px;
    height: 35px;
    overflow: hidden;
    bottom: 0;
}
/deep/.van-calendar__day::after{
     background: #f1f1f1;
    content: '';
    display: block;
    /* margin: 0 1px; */
    width: 95%;
    height: 7px;
    margin:  0 auto;
    position: absolute;
    bottom: 15px;
     z-index: 9;
}
/deep/.van-calendar__day::before{
     background: #f1f1f1;
    content: '';
    display: block;
    /* margin: 0 1px; */
    width: 95%;
    height: 7px;
    margin:  0 auto;
    position: absolute;
    bottom: 1px;
    z-index: 9;
}

</style>
